import React, { Component } from "react";
import PropTypes from "prop-types";
import {
	ActiveSign,
	AgentName,
	Avatar,
	ContactNumber,
	CustomTabs,
	ProfileBar,
	Sign,
	TabItemsCallStyle,
	Title,
	UserList,
} from "../styles/dialpadstyle";

import {
	FormWrapper,
	FormColumn,
	Tip,
	FormGroup,
	ControlLabel,
	FormControl,
	Button,
} from "modules/theme";
import { Tab, Tabs } from "react-bootstrap";
import Spinner from "../../common/components/Spinner";

export class AddCallTheme extends Component {
	constructor(props) {
		super(props);
		this.renderList = this.renderList.bind(this);
		this.state = {
			phone: "",
		};
	}
	renderFormGroup(label, props) {
		return (
			<FormGroup>
				<ControlLabel required={props.required}>{label}</ControlLabel>
				<FormControl {...props} />
			</FormGroup>
		);
	}

	renderList(params, type = '') {
		const { image, status, name, info, width = "40px" } = params;
		const { onTransfer, onTeamSelect } = this.props;
		return (
					<Tip text={name}>
			<ProfileBar style={{ padding: "0px", marginBottom: "10px" }}>
				<Avatar>
					<img style={{ width }} src={image} />
					{type !== 'team' &&
						<ActiveSign>
							<Sign className={status} />
						</ActiveSign>
					}
				</Avatar>
				<Tip text={name}>
					<AgentName style={{
							overflow: "hidden",
							color: "#303030",
							wordBreak: "break-all",
							textAlign: "initial"
						}}>
						{name}
						<ContactNumber>{info}</ContactNumber>
					</AgentName>
				</Tip>
				<Button
					btnStyle="link"
					type="simple"
					onClick={() => {
						type === 'team' ? onTeamSelect(params) : onTransfer(params);
					}}
					style={{ marginLeft: "auto", paddingRight: "0px" }}
					>
					{type === 'team' ? <span className="material-symbols-outlined">navigate_next</span> : <img src={"images/add-member.svg"} />}
				</Button>
			</ProfileBar>
					</Tip>
		);
	}

	renderTeamScreen() {
		const { list, teamList, transferSelectedTeam, onTeamUnSelect } = this.props;
		if (
			transferSelectedTeam &&
			transferSelectedTeam.id &&
			transferSelectedTeam.name
		) {
			return (
				<React.Fragment>
					<Tip text={transferSelectedTeam.name}>
						<div className="fw-bold d-flex justify-content-center align-items-center">
							<button
								className="bg-white border-none mr-4 material-symbols-outlined"
								onClick={() => {
									onTeamUnSelect();
								}}
							>
								keyboard_backspace
							</button>
							{transferSelectedTeam.name}
						</div>
					</Tip>
					<UserList
						style={{
							// height: "auto",
							// maxHeight: 130,
							overflowY: "auto",
							flexGrow: 1,
						}}
					>
						{list.length === 0 ? (
							<span className="text-danger mt-4">
								There are no agents available currently
							</span>
						) : (
							list.map((data) => {
								return this.renderList(data);
							})
						)}
					</UserList>
					<div>
						{/* <Button
							btnStyle={"default"}
							block
							size="xl"
							className="darkblue-btn"
							onClick={() => {
								onTeamUnSelect();
							}}
						>
							back
						</Button> */}
					</div>
				</React.Fragment>
			);
		} else {
			return (
				<UserList style={{ height: "auto", overflowY: "auto" }}>
					{teamList.map((data) => {
						return this.renderList(data, 'team');
					})}
				</UserList>
			);
		}
	}
	render() {
		const {
			title,
			list,
			flowList,
			callState,
			phoneNumber,
			onPhoneChange,
			onTransfer,
			teamList,
			transferSelectedTeam,
			onTransferTab,
			transferTab,
		} = this.props;
		return (
			<div className="h-100">
				<CustomTabs className="h-100">
					{callState == "txAgentLoader" && (
						<React.Fragment>
							<Spinner />
							{phoneNumber && (
								<p
									style={{
										overflow: "hidden",
										textOverflow: "ellipsis",
									}}
								>{`We are tring to connect ${phoneNumber}`}</p>
							)}
						</React.Fragment>
					)}
					{callState != "txAgentLoader" && (
						<Tabs
							defaultActiveKey={transferTab || "agent"}
							onSelect={(k) => {
								onTransferTab(k);
							}}
							id="uncontrolled-tab-example"
							className="customTabs h-100 d-flex flex-column"
						>
							<Title>{title}</Title>
							<Tab eventKey="agent" title="Agent" className="h-100 overflow-y-auto">
								<TabItemsCallStyle>
									<UserList>
										{list.length === 0 && (
											<span className="text-danger">
												There are no agents available currently
											</span>
										)}
										{list.map((data) => {
											return this.renderList(data);
										})}
									</UserList>
								</TabItemsCallStyle>
							</Tab>
							{teamList && teamList.length > 0 && (
								<Tab
									eventKey="team"
									title="Team"
									className="h-100 overflow-y-auto"
								>
									<TabItemsCallStyle>
										{this.renderTeamScreen()}
									</TabItemsCallStyle>
								</Tab>
							)}
							{flowList && flowList.length > 0 && (
								<Tab eventKey="flow" title="Flow" className="h-100 overflow-y-auto">
									<TabItemsCallStyle>
										<UserList>
											{flowList.map((data) => {
												return this.renderList(data);
											})}
										</UserList>
									</TabItemsCallStyle>
								</Tab>
							)}
							<Tab eventKey="phoneno" title="Phone">
								<TabItemsCallStyle>
									<UserList style={{ height: "auto" }}>
										<FormGroup>
											<div style={{ marginTop: "10px" }}>
												{this.renderFormGroup("Phone Number", {
													placeholder: "Enter Phone Number",
													type: "number",
													defaultValue: "",
													required: true,
													type: "text",
													maxLength: 15,
													id: "phone Number",
													value: phoneNumber,
													onChange: (e) => {
														if (!isNaN(e.target.value))
															onPhoneChange(e.target.value);
													},
												})}
											</div>
											<Button
												disabled={!this.props.phoneNumber}
												btnStyle={"default"}
												block
												size="xl"
												className="darkblue-btn"
												onClick={() => {
													let params = {
														type: "externalNumber",
														phone: phoneNumber,
														name: `External Number`,
														info: phoneNumber,
													};
													onTransfer(params);
												}}
											>
												Dial
											</Button>
										</FormGroup>
									</UserList>
								</TabItemsCallStyle>
							</Tab>
						</Tabs>
					)}
				</CustomTabs>
			</div>
		);
	}
}

AddCallTheme.contextTypes = {
	__: PropTypes.func,
};

export default AddCallTheme;



// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/AddCallTheme.js